import { connect } from 'react-redux';
import { ICustomPropertyActionsHOCProps } from './types';
import { CustomPropertyActions } from '../../components/CustomPropertyActions/CustomPropertyActions';
import {
    ICustomPropertyActionsEvents,
    ICustomPropertyActionsFields
} from '../../components/CustomPropertyActions/types';
import { onToggleShowEmpty } from './events/onToggleShowEmpty';
import { onTogglePin } from './events/onTogglePin';
import { IApplicationState } from '../../../../../../../types/types';
import { getCustomPropertiesCreateSelector } from '../selectors/getCustomProperties';
import { getBoardIdByCardId } from '../../../../../../../store/model/selectors/getBoardIdByCardId';
import { ICustomPropertiesElement } from '../../components/CustomProperty/types';
import { ECustomPropertyType } from '../../../../../../../store/customProperties/types';

const mapStateToProps = () => {
    const getCustomProperties = getCustomPropertiesCreateSelector();

    const _mapStateToProps = (
        state: IApplicationState,
        { cardId, customPropertyId }: ICustomPropertyActionsHOCProps
    ): ICustomPropertyActionsFields => {
        const boardId = getBoardIdByCardId(state, cardId);
        const customProperties = getCustomProperties(state, boardId, cardId);
        const customProperty = customProperties.find(customProperty => customProperty.id === customPropertyId) || {} as ICustomPropertiesElement;
        const { pinned, pinnedOnCard, type, value } = customProperty;
        const isPushToCalendar = !!(type === ECustomPropertyType.DATE && value);
        return {
            cardId,
            id: customPropertyId,
            isPinned: pinnedOnCard,
            isPushToCalendar,
            // isShowEmpty: pinned,
        };
    };

    return _mapStateToProps;
};

const mapDispatchToProps = (
    dispatch: any,
    { cardId, customPropertyId }: ICustomPropertyActionsHOCProps
): ICustomPropertyActionsEvents => {
    return {
        onTogglePin: () => dispatch(onTogglePin(cardId, customPropertyId)),
        // onToggleShowEmpty: () => dispatch(onToggleShowEmpty(cardId, customPropertyId)),
    };
};

export const CustomPropertyActionsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomPropertyActions);

CustomPropertyActionsHOC.displayName = 'CustomPropertyActionsHOC';
